import React, { Component } from "react";
import {
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";

class InfoMessage extends Component {

  render() {
    const { infoHeader, infoMessage, clearMessage } = this.props;
    return (
      <Modal isOpen={!!infoMessage} toggle={clearMessage} >
      <ModalHeader toggle={clearMessage}>{infoHeader}</ModalHeader>
      <ModalBody>
        {infoMessage}
      </ModalBody>
      <ModalFooter>
        <Button className="rounded-pill" color="primary" onClick={clearMessage}>Ok</Button>
      </ModalFooter>
    </Modal>
    );
  }
}

export default InfoMessage;